export const MAX_ATTACHMENT_SIZE_BYTES = 20 * 1024 * 1024;

const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB"];

export const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes === null || sizeInBytes === undefined || sizeInBytes === "") {
    return "";
  }

  const bytes = Number(sizeInBytes);

  if (!Number.isFinite(bytes) || bytes < 0) return "";

  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < FILE_SIZE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const formattedValue =
    unitIndex === 0
      ? String(Math.round(value))
      : value.toFixed(1).replace(/\.0$/, "").replace(".", ",");

  return `${formattedValue} ${FILE_SIZE_UNITS[unitIndex]}`;
};

export const MAX_ATTACHMENT_SIZE_MESSAGE = `El archivo supera el tamaño máximo permitido de ${formatFileSize(
  MAX_ATTACHMENT_SIZE_BYTES,
)}.`;

export const MAX_ATTACHMENTS_TOTAL_SIZE_MESSAGE = `La suma de los archivos adjuntos supera el tamaño máximo permitido de ${formatFileSize(
  MAX_ATTACHMENT_SIZE_BYTES,
)}.`;

export const validateAttachmentSize = ({ fileSize, currentTotalSize = 0 }) => {
  const incomingSize = Math.max(0, Number(fileSize) || 0);
  const currentSize = Math.max(0, Number(currentTotalSize) || 0);

  if (incomingSize > MAX_ATTACHMENT_SIZE_BYTES) {
    return MAX_ATTACHMENT_SIZE_MESSAGE;
  }

  if (currentSize + incomingSize > MAX_ATTACHMENT_SIZE_BYTES) {
    return MAX_ATTACHMENTS_TOTAL_SIZE_MESSAGE;
  }

  return null;
};

const FILE_SIZE_MULTIPLIERS = { B: 1, KB: 1024, MB: 1024 ** 2, GB: 1024 ** 3 };

export const parseFileSize = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) && value >= 0 ? value : null;
  }

  if (typeof value !== "string") return null;

  const match = value.trim().match(/^(\d+(?:[.,]\d+)?)\s*([KMG]?B)?$/i);
  if (!match) return null;

  const amount = Number(match[1].replace(",", "."));
  const unit = (match[2] || "B").toUpperCase();

  return Math.round(amount * FILE_SIZE_MULTIPLIERS[unit]);
};

export const getAttachmentSizeInBytes = (attachment = {}) => {
  const candidates = [attachment.size, attachment.file_size, attachment.size_display];

  for (const candidate of candidates) {
    const bytes = parseFileSize(candidate);
    if (bytes !== null) return bytes;
  }

  return null;
};

export const getAttachmentDisplayName = (attachment = {}) => {
  if (attachment.file_name) return attachment.file_name;
  if (attachment.name) return attachment.name;

  if (typeof attachment.file === "string" && attachment.file) {
    return attachment.file.split("/").pop() || "Archivo adjunto";
  }

  return "Archivo adjunto";
};

export const selectFile = ({ accept = "*", multiple = false } = {}) => {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");

    input.type = "file";
    input.accept = accept;
    input.multiple = multiple;
    input.style.display = "none";

    document.body.appendChild(input);

    input.onchange = (event) => {
      const files = Array.from(event.target.files || []);

      document.body.removeChild(input);

      if (!files.length) {
        resolve(null);
        return;
      }

      resolve(multiple ? files : files[0]);
    };

    input.onerror = () => {
      document.body.removeChild(input);
      reject(new Error("Error seleccionando archivo."));
    };

    input.click();
  });
};
